interface QuantitySelectorProps {
  quantity: number;
  incrementQuantity: () => void;
  decrementQuantity: () => void;
  sku: string;
}

export const QuantitySelector = ({ 
  quantity, 
  incrementQuantity, 
  decrementQuantity, 
  sku 
}: QuantitySelectorProps) => (
  <div className="flex-col sm:flex-row flex mt-6 sm:items-center border-gray-200 mb-5 sm:divide-x">
    <div className="flex items-center pr-6">
      <span className="mr-3">Quantity</span>
      <div className="mt-1 flex rounded-md shadow-sm">
        <input
          type="number"
          readOnly
          min={1}
          max={99}
          value={quantity}
          className="focus:ring-indigo-500 focus:border-indigo-500 block max-w-min rounded-none rounded-l-md sm:text-sm border-gray-300 px-6"
        />
        <div className="flex">
          <button
            onClick={decrementQuantity}
            className="px-2 py-2 border border-gray-300 rounded-l-md"
          >
            <svg
              className="h-5 w-5 text-gray-400"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 10.586V7z"
                clipRule="evenodd"
              />
            </svg>
          </button>
          <button
            onClick={incrementQuantity}
            className="px-2 py-2 border border-gray-300 rounded-r-md"
          >
            <svg
              className="h-5 w-5 text-gray-400"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L9 9.414V13a1 1 0 102 0V9.414l1.293 1.293a1 1 0 001.414-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
    <div className="flex sm:pl-6 pb-2 pt-2 mt-4 sm:mt-0">
      <p className="font-normal">SKU:</p>
      <p className="font-semibold pl-3">{sku}</p>
    </div>
  </div>
);